// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { EServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel } from './eServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel.js';
import type { EntlibFailureEServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel } from './entlibFailureEServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel.js';
import type { EntlibResponseEServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel } from './entlibResponseEServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel.js';
import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class PharmacyV1TripleCheckRequestResponse {
    'data': EServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel | null;
    'success': boolean;
    'messages': Array<string> | null;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof PharmacyV1TripleCheckRequestResponse>> = [
        {
            "name":     "data",
            "baseName": "data",
            "type":     "EServicesOrchestratorServicePublicNewPathModelsTripleCheckResponseModel"
        },
        {
            "name":     "success",
            "baseName": "success",
            "type":     "boolean"
        },
        {
            "name":     "messages",
            "baseName": "messages",
            "type":     "Array<string>"
        },
    ];

    static getAttributeTypeMap() {
        return PharmacyV1TripleCheckRequestResponse.attributeTypeMap;
    }
}
